// pages/testimonials/TestimonialAction.js
import {
  isPending,
  createTestimonialSuccess,
  getTestimonialsSuccess,
  getSingleTestimonialSuccess,
  updateTestimonialSuccess,
  deleteTestimonialSuccess,
  testimonialFail,
} from "./TestimonialsSlice";
import testimonialAPI from "../../apis/testimonialApi";

// Helpers to normalize various API shapes
const pickArray = (res) =>
  Array.isArray(res)
    ? res
    : Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.data?.testimonials)
    ? res.data.testimonials
    : [];

const pickObject = (res) =>
  res && res._id
    ? res
    : res?.data && res?.data._id
    ? res.data
    : res?.data?.testimonial && res?.data?.testimonial._id
    ? res.data.testimonial
    : null;

// Create
export const createTestimonialAction =
  (testimonialData) => async (dispatch) => {
    dispatch(isPending());
    try {
      const res = await testimonialAPI.createNewTestimonial(testimonialData);
      const obj = pickObject(res);
      if (obj) {
        dispatch(createTestimonialSuccess(obj));
        return obj;
      }
      return dispatch(testimonialFail(res));
    } catch (error) {
      dispatch(testimonialFail(error));
      return error;
    }
  };

// Get all
export const fetchTestimonialsAction = () => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await testimonialAPI.fetchTestimonials();
    const arr = pickArray(res);
    if (arr.length >= 0) {
      dispatch(getTestimonialsSuccess(arr));
      return arr;
    }
    return dispatch(testimonialFail(res));
  } catch (error) {
    dispatch(testimonialFail(error));
    return error;
  }
};

// Get single
export const fetchSingleTestimonialAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await testimonialAPI.fetchTestimonials(_id);
    const obj = pickObject(res);
    if (obj) {
      dispatch(getSingleTestimonialSuccess(obj));
      return obj;
    }
    return dispatch(testimonialFail(res));
  } catch (error) {
    dispatch(testimonialFail(error));
    return error;
  }
};

// Update
export const updateTestimonialAction =
  (_id, testimonialData) => async (dispatch) => {
    dispatch(isPending());
    try {
      const res = await testimonialAPI.updateTestimonial(_id, testimonialData);
      const obj = pickObject(res);
      if (obj) {
        dispatch(updateTestimonialSuccess(obj)); // must be the updated object with _id
        return obj;
      }
      return dispatch(testimonialFail(res));
    } catch (error) {
      dispatch(testimonialFail(error));
      return error;
    }
  };

// Delete
export const deleteTestimonialAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    await testimonialAPI.deleteTestimonial(_id);
    dispatch(deleteTestimonialSuccess(_id)); // dispatch the id we deleted
    return _id;
  } catch (error) {
    dispatch(testimonialFail(error));
    return error;
  }
};
